import React from "react";

import adp from "../../../assets/overview_img/integration/market-place-adp.png.webp";
import alight from "../../../assets/overview_img/integration/market-place-alight.png.webp";
import paycor from "../../../assets/overview_img/integration/market-place-paycor.png.webp";
import ukg from "../../../assets/overview_img/integration/market-place-ukg.png.webp";
import viventium from "../../../assets/overview_img/integration/market-place-viventium.png.webp";

import oracle from "../../../assets/overview_img/integration/oracle-partner-logos.png.webp";
import par from "../../../assets/overview_img/integration/par-logo.webp";
import paylocity from "../../../assets/overview_img/integration/paylocity-logo.svg";
import sap from "../../../assets/overview_img/integration/sap-partner-logo-1.png.webp";
import workday from "../../../assets/overview_img/integration/workday-new-logo.webp";

function IntegrationSection() {
  const logos = [
    adp,
    alight,
    par,
    oracle,
    workday,
    sap,
    paycor,
    ukg,
    viventium,
    paylocity,
  ];

  return (
    <section className="bg-white mt-[80px] lg:mt-0 py-[30px] sm:py-14 lg:py-20 px-4">
      <div
        className="
          max-w-[1300px]
min-h-[510px]
lg:h-[480px]         
 mx-auto
 sm:h-[500px]
 md:h-[790px]
 h-[720px]

          bg-[#270202]

          rounded-[5px]
          sm:rounded-[34px]
          md:rounded-[5px]
          lg:rounded-[5px]

          overflow-hidden

          px-5
          sm:px-8
          lg:px-16

          py-8
          sm:py-12
          lg:py-6
        "
      >
        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-[1.2fr_0.8fr]

            gap-10
            lg:gap-16

            items-center
          "
        >
          {/* LEFT CONTENT */}
          <div className="text-white -mt-4 sm:-mt-6 lg:-mt-14 mb-0">
            <h2
              className="
                font-sans

                text-[24px]
                leading-[34px]

                sm:text-[48px]
                sm:leading-[42px]

                md:text-[24px]
                md:font-extrabold
                md:max-w-[550px]
                md:leading-[36px]
                

                lg:text-[34px]
                lg:font-sans
                lg:leading-[40px]
                lg:tracking-tight

                max-w-[760px]
                mt-4
              "
            >
              Simple Implementation.
              <br className="md:hidden" />
              Seamless Integrations.
            </h2>

            <p
  className="
    mt-6
    lg:mt-8
    text-[15px]
    leading-[1.5]
    lg:leading-[1.5]

    sm:text-[17px]
    lg:text-[17px]

    max-w-[720px]
    md:max-w-[500px]
  "
>
  Implementing DailyPay is a straightforward process
  that can be
  <br className="hidden lg:block md:block" />

  completed in as little as 15 minutes,
  designed to give you more
  <br className="hidden lg:block md:block" />

  flexibility and control
  with minimal disruption to your existing
  <br className="hidden lg:block md:block" />

  systems. DailyPay seamlessly integrates
  with over 180 leading
  <br className="hidden lg:block md:block" />

  HCM, payroll, and time management systems,
  including
  <br className="hidden lg:block md:block" />

  partners like ADP, Workday, and more.
</p>

            <p
              className="
                mt-8
                lg:mt-6

                text-[15px]
                leading-[1.0]

                sm:text-[17px]

                lg:text-[16px]

                max-w-[680px]
              "
            >
              Explore our full list of integrations and see how
              simple it is to <br /> get started.
            </p>

            <button
              className="
                mt-8
                lg:mt-6

                border-2
                border-white

                px-6
                py-1

                sm:px-4
                sm:py-4
                md:px-6
                md:py-2
                lg:px-3
                lg:py-1

                text-[15px]
                sm:text-[17px]

                font-semibold

                hover:bg-white
                hover:text-[#4b0000]

                transition-all
                duration-300
              "
            >
              View all integrations
            </button>
          </div>

          
{/* RIGHT GRID */}
<div
  className="
    grid
    grid-cols-3

    gap-y-3
    sm:gap-y-5
    lg:gap-y-4

    gap-x-3
    sm:gap-x-8
    lg:gap-x-8

    mx-auto
    -mr-6
    lg:mr-[40px]

    
    
  "
>
  {[
    adp,
    alight,
    par,

    oracle,
    workday,
    sap,

    paycor,
    ukg,
    viventium,

    null,
    paylocity,
    null,
  ].map((logo, index) => (
    <div
      key={index}
      className={`
        bg-white

        rounded-[5px]
        sm:rounded-[14px]
        md:rounded-none
        lg:rounded-[4px]

        h-[60px]
        sm:h-[95px]
        

        ${
          index === 10
            ? "lg:h-[82px]"
            : "lg:h-[125px]"
        }

        w-[62px]
        sm:w-[120px]
        lg:w-[130px]

        flex
        items-center
        justify-center

        p-2
        sm:p-4

        shadow-md

        transition-all
        duration-300

        ${
          index % 3 === 1
            ? "-mt-4 lg:-mt-8"
            : ""
        }
      `}
    >
      {logo ? (
        <img
          src={logo}
          alt="logo"
          className={`
            object-contain

            max-w-[38px]
            sm:max-w-[80px]
            lg:max-w-[100px]

            max-h-[20px]
            md:max-h-[50px]
            lg:max-h-[70px]

            ${
              index === 10
                ? "lg:max-h-[38px]"
                : ""
            }
          `}
        />
      ) : (
        <div className="w-full h-full bg-white" />
      )}
    </div>
  ))}
</div>
</div>
</div>
    </section>
  );
}

export default IntegrationSection;